import React, { useState } from "react";
import axios from "axios";
import { API_BASE } from "../utils/apiBase";

/** Shared newsletter subscribe form (desktop floating card + mobile strip) */
export default function NewsletterForm({ className = "" }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      await axios.post(`${API_BASE}/newsletter-subscribers`, {
        data: { email: email.toLowerCase() },
      });
      setSent(true);
      setEmail("");
    } catch (err) {
      const message = err?.response?.data?.error?.message || "";
      if (message === "This attribute must be unique") {
        setError("You're already subscribed.");
      } else {
        setError("Oops, something went wrong.");
      }
    }
  };

  if (sent) {
    return (
      <p className={`text-sm text-emerald-400 ${className}`}>
        Thanks! ✉️ We’ll keep you posted.
      </p>
    );
  }

  return (
    <form onSubmit={handleSubmit} className={`space-y-2 ${className}`}>
      <input
        type="email"
        required
        placeholder="you@email.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-full rounded-md bg-white/10 px-3 py-2
                   placeholder-white/70 focus:outline-none"
      />
      {error && <p className="text-xs text-red-400">{error}</p>}
      <button
        type="submit"
        className="w-full bg-white/10 hover:bg-white/20 rounded-md py-2
                   text-sm font-semibold transition-colors"
      >
        Subscribe
      </button>
    </form>
  );
}
